/* ============================================================================
   dcg-discount-star.js
   Keeps the product-page discount star's "% Off" in sync when the customer
   changes condition/variant.

   The star itself is rendered server-side in product-template.liquid (correct on
   first paint). theme.js (Slate) fires a jQuery `variantChange` event on the
   product container with the selected `variant` object; that event bubbles to
   document, so we listen there without touching theme.js. The collection-card
   star is handled separately in dcg-product-card.js.

   Scope: product page only. No-ops if jQuery or the star are absent.
   ========================================================================== */
(function () {
  'use strict';

  function updateStar(root, variant) {
    var star = root.querySelector('.dcg-discount-star');
    if (!star) return;

    var compare = variant ? Number(variant.compare_at_price) : 0;
    var price   = variant ? Number(variant.price) : 0;

    if (compare && price && compare > price) {
      var pctEl = star.querySelector('.dcg-discount-star__pct');
      if (pctEl) pctEl.textContent = Math.round((1 - price / compare) * 100) + '%';
      star.style.display = '';
    } else {
      // Selected variant isn't discounted — hide the star.
      star.style.display = 'none';
    }
  }

  function init() {
    var root = document.querySelector('[data-dcg-product-root]');
    if (!root || !root.querySelector('.dcg-discount-star')) return;
    if (typeof window.jQuery === 'undefined') return; // theme.js variantChange is jQuery-based

    window.jQuery(document).on('variantChange', function (evt) {
      // Slate triggers .trigger({ type:'variantChange', variant: variant })
      if (evt && evt.variant) updateStar(root, evt.variant);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
